"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["Advertisement"] = "ADVERTISEMENT";
    PageType["Content"] = "CONTENT";
    PageType["Quiz"] = "QUIZ";
    PageType["Webinar"] = "WEBINAR";
})(PageType || (exports.PageType = PageType = {}));
